import { motion, useReducedMotion } from "framer-motion";

/**
 * Gently fades + rises its children into view once, the first time they
 * scroll into the viewport. No-ops (renders a plain div) for users who
 * prefer reduced motion.
 */
export function Reveal({ children, className, delay = 0, as = "div" }) {
  const prefersReduced = useReducedMotion();
  const Tag = as;

  if (prefersReduced) {
    return <Tag className={className}>{children}</Tag>;
  }

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.5, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}
